/* Match the existing purchase guard, including tracked stock already in the cart. */
window.MouniShadeStock ||= (() => {
  let cart=null;
  try{cart=JSON.parse(document.querySelector('[data-mouni-cart-snapshot]')?.textContent||'null');}catch{}
  const available=variant=>{
    if(!variant?.available)return false;
    if(!variant.inventory_management)return true;
    if(!Number.isFinite(Number(variant.inventory_quantity)))return variant.available;
    const current=cart||window.MouniCommerce?.cart;
    if(window.MouniCommerce?.remaining)return window.MouniCommerce.remaining(variant,current)>0;
    const used=(current?.items||[]).reduce((sum,item)=>sum+(String(item.variant_id??item.id)===String(variant.id)?Number(item.quantity)||0:0),0);
    return Number(variant.inventory_quantity)>used;
  };
  const adopt=event=>{const next=event.detail?.cart||event.detail;if(!next?.items)return;cart=next;document.dispatchEvent(new CustomEvent('mouni:shade-stock-change'));};
  ['mouni:inventory-cart','mouni:cart-updated','mouni:v37-cart-painted','mouni:cart-html-refreshed'].forEach(name=>document.addEventListener(name,adopt));
  return {available};
})();


if (!customElements.get('mouni-home-products')) customElements.define('mouni-home-products', class extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController();
    queueMicrotask(() => this.initialize());
  }
  disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  initialize() {
    if (!this.abort) return;
    const signal = this.abort.signal;
    this.addEventListener('submit', event => {
      const form=event.target;
      if(!form.matches('form[data-mouni-enabled="true"]') || form.dataset.mouniBound==='true') return;
      event.preventDefault();event.stopImmediatePropagation();
      const button=event.submitter;
      const resume=()=>{ window.MouniCommerce?.bind(this); if(form.dataset.mouniBound==='true') form.requestSubmit(button); };
      if(window.MouniCommerce) resume();
      else document.querySelector('script[src*="product-form.js"]')?.addEventListener('load',resume,{once:true,signal});
    },{capture:true,signal});
    const tabs = [...this.querySelectorAll('[role=tab]')];
    const activate = tab => tabs.forEach(t => {
      const selected = t === tab;
      t.setAttribute('aria-selected', String(selected)); t.tabIndex = selected ? 0 : -1;
      this.querySelector('#' + t.getAttribute('aria-controls')).hidden = !selected;
    });
    this.addEventListener('click', e => { const tab=e.target.closest('[role=tab]'); if(tab) activate(tab); }, {signal});
    this.addEventListener('keydown', e => {
      const i=tabs.indexOf(e.target); if(i<0)return;
      const n=e.key==='ArrowLeft'?(i+1)%tabs.length:e.key==='ArrowRight'?(i-1+tabs.length)%tabs.length:e.key==='Home'?0:e.key==='End'?tabs.length-1:null;
      if(n!==null){e.preventDefault();activate(tabs[n]);tabs[n].focus();}
    }, {signal});
    this.addEventListener('shopify:block:select', e => {const tab=tabs.find(t=>t.id.endsWith(e.detail.blockId));if(tab)activate(tab);}, {signal});

    window.MouniCommerce?.bind(this);
  }
});

(() => {
  if(!document.body.classList.contains('template-product'))return;
  const roots=new Map(),motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  const groupSelector='.rio-options [data-option-type="swatch"],variant-radios .product-form__swatch';
  const mount=root=>{
    const controller=new AbortController(),signal=controller.signal,groups=new Map();
    const chosenOptions=new Set(),pendingOptions=new Set(),guardedForms=new Map();
    let animations=[],targets=[],frame=0,keyboardAction=null,keyboardTimer=0;
    const syncPurchase=()=>{
      const pending=pendingOptions.size>0;
      root.toggleAttribute('data-mouni-choice-pending',pending);
      root.querySelectorAll('form[data-mouni-enabled="true"]').forEach(form=>{
        if(form.closest('mouni-product-card'))return;
        if(pending){
          if(!guardedForms.has(form))guardedForms.set(form,{required:form.dataset.mouniRequiresChoice,made:form.dataset.mouniChoiceMade,label:form.dataset.choiceLabel});
          form.dataset.mouniRequiresChoice='true';form.dataset.mouniChoiceMade='false';form.dataset.choiceLabel='اختاري درجتك';
          window.MouniCommerce?.syncForm(form);
        }else if(guardedForms.has(form)){
          const previous=guardedForms.get(form);
          for(const [key,value] of [['mouniRequiresChoice',previous.required],['mouniChoiceMade',previous.made],['choiceLabel',previous.label]]){
            if(value===undefined)delete form.dataset[key];else form.dataset[key]=value;
          }
          guardedForms.delete(form);window.MouniCommerce?.syncForm(form);
        }
      });
      let notice=root.querySelector('.mouni-pdp-choice-status');
      const picker=root.querySelector('.rio-options')||root.querySelector('variant-radios');
      if(pending&&!notice&&picker){notice=document.createElement('p');notice.className='mouni-pdp-choice-status';notice.setAttribute('role','status');notice.textContent='اختاري درجة اللون لإضافتها إلى السلة';picker.after(notice);}
      if(notice&&notice.hidden===pending)notice.hidden=!pending;
    };
    const stop=()=>{animations.forEach(animation=>animation.cancel());animations=[];targets=[];};
    const entries=()=>{
      const picker=root.querySelector('variant-radios'),fields=[...picker?.querySelectorAll('fieldset')||[]];
      let variants=[];
      try{variants=JSON.parse(picker?.querySelector('script[type="application/json"]')?.textContent||'[]');}catch(error){return [];}
      let stock=[];
      try{stock=JSON.parse(root.querySelector('[data-mouni-stock-variants]')?.textContent||'[]');}catch{}
      variants=variants.map(variant=>({...variant,...stock.find(item=>String(item.id)===String(variant.id))}));
      const selected=fields.map(field=>field.querySelector('input:checked')?.value);
      return [...groups.keys()].flatMap(group=>{
        const native=group.matches('.product-form__swatch');
        const index=native?Number(group.dataset.optionIndex):fields.findIndex(field=>field.querySelector('input')?.name===group.dataset.option);
        if(index<0)return [];
        return [...group.querySelectorAll(native?'label.product-form__label':'[data-option-value]')].map(node=>{
          const input=native?[...group.querySelectorAll('input')].find(input=>input.id===node.htmlFor):null;
          const value=native?input?.value:node.dataset.optionValue;
          const blocked=node.matches('.soldout,.unavailable,[aria-disabled="true"],[disabled]')||input?.disabled||[...node.classList].some(name=>name.startsWith('rio-swatch-unavailable-'));
          const available=!blocked&&variants.some(variant=>window.MouniShadeStock.available(variant)&&variant.options[index]===value&&variant.options.every((option,i)=>i===index||!selected[i]||option===selected[i]));
          return {node,input,group,index,value,selected:selected[index],available};
        });
      });
    };
    const sync=()=>{
      frame=0;
      if(signal.aborted)return;
      for(const group of root.querySelectorAll(groupSelector))if(!groups.has(group)){groups.set(group,!observer);observer?.observe(group);}
      for(const group of groups.keys())if(!root.contains(group)){observer?.unobserve(group);groups.delete(group);}
      const shades=entries();
      for(const group of groups.keys()){
        const index=shades.find(entry=>entry.group===group)?.index;
        group.toggleAttribute('data-mouni-choice-pending',pendingOptions.has(index));
      }
      // Read the native picker after its own handlers; never replace its variant state.
      for(const index of chosenOptions)if(shades.some(entry=>entry.index===index)&&!shades.some(entry=>entry.index===index&&entry.selected))chosenOptions.delete(index);
      shades.forEach(entry=>{
        const unavailable=String(!entry.available);
        if(entry.node.dataset.mouniShadeUnavailable!==unavailable)entry.node.dataset.mouniShadeUnavailable=unavailable;
        let slash=entry.node.querySelector('.mouni-shade-slash');
        if(!entry.available&&!slash){slash=document.createElement('span');slash.className='mouni-shade-slash';slash.setAttribute('aria-hidden','true');entry.node.append(slash);}
        if(slash&&slash.hidden!==entry.available)slash.hidden=entry.available;
        const label=entry.value+(entry.available?'':' — غير متوفر');
        if(entry.node.title!==label)entry.node.title=label;
        let status=entry.node.querySelector('.mouni-shade-stock-label');
        if(!entry.available&&!status){status=document.createElement('span');status.className='mouni-shade-stock-label visually-hidden';status.textContent='غير متوفر';entry.node.append(status);}
        if(status&&status.hidden!==entry.available)status.hidden=entry.available;
        const selected=chosenOptions.has(entry.index)&&entry.value===entry.selected;
        const state=String(selected);
        if(entry.node.dataset.mouniShadeSelected!==state)entry.node.dataset.mouniShadeSelected=state;
        if(!entry.input&&entry.node.getAttribute('aria-pressed')!==state)entry.node.setAttribute('aria-pressed',state);
        let check=entry.node.querySelector('.mouni-pdp-shade-check');
        if(selected&&!check){check=document.createElement('span');check.className='mouni-pdp-shade-check';check.setAttribute('aria-hidden','true');check.textContent='✓';entry.node.append(check);}
        if(check&&check.hidden===selected)check.hidden=!selected;
      });
      syncPurchase();
      const next=document.hidden||motion.matches?[]:shades.filter(entry=>!chosenOptions.has(entry.index)&&entry.available&&groups.get(entry.group)&&entry.node.getClientRects().length).map(entry=>entry.node);
      if(next.length===targets.length&&next.every((node,i)=>node===targets[i]))return;
      stop();targets=next;
      const count=targets.length;
      targets.forEach((node,index)=>{
        node.dataset.mouniPdpShade='true';
        let halo=node.querySelector('.mouni-pdp-shade-halo');
        if(!halo){halo=document.createElement('span');halo.className='mouni-pdp-shade-halo';halo.setAttribute('aria-hidden','true');node.append(halo);}
        if(!halo.animate)return;
        animations.push(halo.animate([
          {opacity:0,offset:0,easing:'ease-in-out'},
          {opacity:1,offset:.28/count},
          {opacity:1,offset:.62/count,easing:'ease-in-out'},
          {opacity:0,offset:.94/count},
          {opacity:0,offset:1}
        ],{duration:1000*count,delay:1000*index,iterations:Infinity,easing:'linear'}));
      });
    };
    const schedule=()=>{if(!signal.aborted&&!frame)frame=requestAnimationFrame(sync);};
    const observer='IntersectionObserver' in window?new IntersectionObserver(changes=>{changes.forEach(entry=>groups.set(entry.target,entry.isIntersecting));schedule();}):null;
    const mutations=new MutationObserver(changes=>{
      if(changes.some(change=>change.target.closest?.('.rio-options,variant-radios')||[...change.addedNodes].some(node=>node.nodeType===1&&(node.matches?.('.rio-options,variant-radios,form[data-mouni-enabled]')||node.querySelector?.('.rio-options,variant-radios,form[data-mouni-enabled]')))))schedule();
    });
    mutations.observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['class','hidden','checked','aria-disabled','disabled']});
    const choose=event=>{
      if(!event.isTrusted){schedule();return;}
      const entry=entries().find(entry=>entry.available&&(entry.node.contains(event.target)||entry.input===event.target));
      if(!entry)return;
      if(event.type==='click'&&keyboardAction?.node===entry.node){
        if(keyboardAction.cleared){event.preventDefault();event.stopImmediatePropagation();}
        keyboardAction=null;schedule();return;
      }
      const clear=event.type!=='change'&&entry.node.dataset.mouniShadeSelected==='true';
      if(event.type==='keydown')keyboardAction={node:entry.node,cleared:clear};
      if(clear){
        // Keep the app's last variant as a preview, but require a fresh confirmed choice before purchase.
        event.preventDefault();event.stopImmediatePropagation();
        chosenOptions.delete(entry.index);pendingOptions.add(entry.index);
        syncPurchase();stop();schedule();return;
      }
      pendingOptions.delete(entry.index);chosenOptions.add(entry.index);syncPurchase();stop();schedule();
    };
    root.addEventListener('click',choose,{capture:true,signal});
    root.addEventListener('change',choose,{capture:true,signal});
    root.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' ')choose(event);},{capture:true,signal});
    root.addEventListener('keyup',event=>{
      if(keyboardAction?.cleared&&(event.key==='Enter'||event.key===' ')){event.preventDefault();event.stopImmediatePropagation();}
      clearTimeout(keyboardTimer);keyboardTimer=setTimeout(()=>{keyboardAction=null;},0);
    },{capture:true,signal});
    root.addEventListener('submit',event=>{if(pendingOptions.size&&!event.target.closest('mouni-product-card')&&event.target.matches('form[action*="/cart/add"]')){event.preventDefault();event.stopImmediatePropagation();syncPurchase();}},{capture:true,signal});
    root.addEventListener('click',event=>{if(pendingOptions.size&&!event.target.closest('mouni-product-card')&&event.target.closest('[data-mouni-atc],[data-mouni-buy-now],.shopify-payment-button__button')){event.preventDefault();event.stopImmediatePropagation();syncPurchase();}},{capture:true,signal});
    root.addEventListener('reset',()=>{chosenOptions.clear();pendingOptions.clear();syncPurchase();schedule();},{capture:true,signal});
    document.addEventListener('visibilitychange',schedule,{signal});
    document.addEventListener('mouni:shade-stock-change',schedule,{signal});
    motion.addEventListener('change',schedule,{signal});
    const dispose=()=>{controller.abort();stop();cancelAnimationFrame(frame);clearTimeout(keyboardTimer);mutations.disconnect();observer?.disconnect();};
    roots.set(root,dispose);sync();
  };
  const initialize=()=>{
    for(const [root,dispose] of roots)if(!root.isConnected){dispose();roots.delete(root);}
    document.querySelectorAll('#MainContent [id^="ProductSection-"]').forEach(root=>{if(!roots.has(root))mount(root);});
  };
  document.addEventListener('shopify:section:load',initialize);
  document.addEventListener('shopify:section:unload',event=>{for(const [root,dispose] of roots)if(event.target.contains(root)){dispose();roots.delete(root);}});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
})();

if(!customElements.get('mouni-product-card'))customElements.define('mouni-product-card',class extends HTMLElement {
connectedCallback(){if(this.abort)return;this.abort=new AbortController();queueMicrotask(()=>{if(this.abort){this.prepareCard(this,this.abort.signal);window.MouniCommerce?.bind(this);}});}
disconnectedCallback(){this.abort?.abort();this.abort=null;}
  async decode(value) {
    if (typeof value === 'string') value = JSON.parse(value);
    if (value?.compressed) {
      const bytes = Uint8Array.from(atob(value.compressed), c => c.charCodeAt(0));
      const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'));
      return JSON.parse(await new Response(stream).text());
    }
    return value;
  }
  async prepareCard(card, signal) {
    const variants=JSON.parse(card.querySelector('[data-mouni-variants]').textContent);
    const data=JSON.parse(card.querySelector('[data-mhp-gallery]').textContent);
    const form=card.querySelector('form'), input=form.querySelector('[name=id]');
    let mapping, swatches;
    try { [mapping,swatches]=await Promise.all([this.decode(data.mapping),this.decode(data.swatches)]); } catch(error) { console.warn('MOUNI: could not read variant gallery',error); }
    if(signal.aborted)return;
    const fieldsets=[...card.querySelectorAll('[data-option-index]')];
    let selected=variants.find(v=>String(v.id)===input.value)||variants[0];
    const initialVariant=selected;
    const chosenOptions=new Set();
    const choiceHint=card.querySelector('[data-choice-hint]');
    const options=card.querySelector('.mhp__options');
    const shadeMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
    let shadeAnimations=[],shadesInView=!('IntersectionObserver' in window);
    const stopShadeInvite=()=>{shadeAnimations.forEach(animation=>animation.cancel());shadeAnimations=[];};
    const syncShadeInvite=()=>{
      stopShadeInvite();
      if(signal.aborted||!shadesInView||document.hidden||shadeMotion.matches||card.dataset.choiceMotion!=='true')return;
      const available=[...card.querySelectorAll('.mhp__swatches--pending .mhp__swatch:not([data-unavailable=true])')].filter(button=>{
        const fill=button.querySelector('.mhp__swatch-fill');
        return fill&&!fill.querySelector('span');
      });
      const count=available.length;
      available.forEach((button,index)=>{
        let halo=button.querySelector('.mhp__shade-halo');
        if(!halo){halo=document.createElement('span');halo.className='mhp__shade-halo';halo.setAttribute('aria-hidden','true');button.append(halo);}
        if(!halo.animate)return;
        shadeAnimations.push(halo.animate([
          {opacity:0,offset:0,easing:'ease-in-out'},
          {opacity:1,offset:.28/count},
          {opacity:1,offset:.62/count,easing:'ease-in-out'},
          {opacity:0,offset:.94/count},
          {opacity:0,offset:1}
        ],{duration:1000*count,delay:1000*index,iterations:Infinity,easing:'linear'}));
      });
    };
    const shadeObserver='IntersectionObserver' in window?new IntersectionObserver(entries=>{
      shadesInView=entries.some(entry=>entry.isIntersecting);syncShadeInvite();
    },{threshold:0}):null;
    if(options)shadeObserver?.observe(options);
    document.addEventListener('visibilitychange',syncShadeInvite,{signal});
    shadeMotion.addEventListener('change',syncShadeInvite,{signal});
    signal.addEventListener('abort',()=>{stopShadeInvite();shadeObserver?.disconnect();},{once:true});
    let hintFrame=0;
    const positionChoiceHint=()=>{
      if(signal.aborted)return;
      options?.querySelectorAll('[data-hint-row]').forEach(button=>button.removeAttribute('data-hint-row'));
      fieldsets.forEach((fieldset,i)=>{
        const hasAvailable=[...fieldset.querySelectorAll('.mhp__swatch')].some(button=>button.dataset.unavailable!=='true');
        fieldset.querySelector('.mhp__swatches')?.classList.toggle('mhp__swatches--pending',hasAvailable&&!chosenOptions.has(i));
      });
      if(choiceHint)choiceHint.hidden=!options?.querySelector('.mhp__swatches--pending');
      syncShadeInvite();
    };
    const scheduleChoiceHint=()=>{cancelAnimationFrame(hintFrame);hintFrame=requestAnimationFrame(positionChoiceHint);};
    signal.addEventListener('abort',()=>cancelAnimationFrame(hintFrame),{once:true});
    const choicePrompt=card.querySelector('[data-choice-prompt]');
    const choiceNotice=card.querySelector('[data-choice-notice]');
    let choiceNoticeTimer;
    choicePrompt?.addEventListener('click',()=>{
      if(chosenOptions.size===fieldsets.length)return;
      const pending=fieldsets.find((fieldset,i)=>!chosenOptions.has(i));
      const label=pending?.querySelector('legend')?.textContent.trim()||'الخيارات';
      choiceNotice.textContent=label==='اللون'?'يرجى اختيار درجة اللون':'يرجى اختيار '+label;
      clearTimeout(choiceNoticeTimer);
      choiceNoticeTimer=setTimeout(()=>{choiceNotice.textContent='';},4500);
    },{signal});
    signal.addEventListener('abort',()=>clearTimeout(choiceNoticeTimer),{once:true});
    let gallery=[], position=0;
    const resolveGallery = v => {
      const match=mapping?.enabled && mapping.mapping?.find(m=>String(m.id)===String(v.id));
      if(match?.media?.length){return match.media.map(id=>data.media.find(m=>String(m.id)===String(id))).filter(Boolean);}
      if(variants.length===1)return data.media;
      const images=data.media.filter(m=>m.src===v.image || (m.alt && v.options.some(o=>m.alt===o)));
      return images.length?images:v.image?[{src:v.image,alt:card.querySelector('h3').textContent}]:data.media.slice(0,1);
    };
    const paintImages = () => {
      const image=card.querySelector('.mhp__image'), second=card.querySelector('.mhp__image--next'), next=card.querySelector('[data-gallery-next]');
      const item=gallery[position];
      if(item){image.removeAttribute('srcset');image.src=item.src;image.alt=item.alt||card.querySelector('h3').textContent;}
      const upcoming=gallery[(position+1)%gallery.length];
      second.hidden=gallery.length<2;
      if(upcoming&&gallery.length>1){second.src=upcoming.src;second.alt=upcoming.alt||image.alt;}
      next.hidden=gallery.length<2;
      next.querySelector('[data-gallery-count]').textContent=gallery.length>1?`${position+1}/${gallery.length}`:'';
    };
    const syncAvailability=(v=selected)=>{
      fieldsets.forEach((fieldset,i)=>{
        const optionTitle=fieldset.querySelector('[data-option-title]');
        optionTitle.hidden=!chosenOptions.has(i);
        optionTitle.textContent=chosenOptions.has(i)?': '+v.options[i]:'';
        fieldset.querySelectorAll('[data-option-value]').forEach(button=>{
          const value=button.dataset.optionValue;
          button.setAttribute('aria-pressed',String(chosenOptions.has(i)&&value===v.options[i]));
          button.dataset.unavailable=String(!variants.some(choice=>window.MouniShadeStock.available(choice)&&choice.options[i]===value&&choice.options.every((o,j)=>j===i||o===v.options[j])));
          const label=value+(button.dataset.unavailable==='true'?' — غير متوفر':'');
          button.setAttribute('aria-label',label);button.title=label;
        });
      });
      scheduleChoiceHint();
    };
    document.addEventListener('mouni:shade-stock-change',()=>syncAvailability(),{signal});
    const update = v => {
      if(!v)return; selected=v; input.value=String(v.id);
      card.querySelector('[data-mhp-price]').textContent=v.price_text;
      const compare=card.querySelector('[data-mhp-compare]');if(compare){compare.hidden=!(v.compare_at_price>v.price);compare.textContent=v.compare_text;}
      const badge=card.querySelector('[data-mhp-badge]');if(badge){badge.hidden=!(v.compare_at_price>v.price);badge.textContent=Math.round((v.compare_at_price-v.price)/v.compare_at_price*100)+'%';}
      syncAvailability(v);
      if(chosenOptions.size===fieldsets.length&&choiceNotice){clearTimeout(choiceNoticeTimer);choiceNotice.textContent='';}
      gallery=resolveGallery(v); position=0; paintImages();
      card.querySelectorAll('a[href*="/products/"]').forEach(a=>{const u=new URL(a.href);u.searchParams.set('variant',v.id);a.href=u.href;});
      window.MouniCommerce?.syncForm(form);
    };
    const resetChoiceOutside=event=>{
      if(!chosenOptions.size||card.contains(event.target))return;
      chosenOptions.clear();
      form.dataset.mouniChoiceMade='false';
      if(choiceNotice){clearTimeout(choiceNoticeTimer);choiceNotice.textContent='';}
      update(initialVariant);
    };
    document.addEventListener('pointerdown',resetChoiceOutside,{capture:true,signal});
    document.addEventListener('focusin',resetChoiceOutside,{signal});
    fieldsets.forEach((fieldset,i)=>{
      const appOption=swatches?.enabled&&swatches.options?.[i];
      fieldset.querySelectorAll('[data-option-value]').forEach(button=>{
        const value=button.dataset.optionValue, cfg=appOption?.values?.find(o=>o.id===value||o.name===value)?.config;
        const fill=button.querySelector('.mhp__swatch-fill');
        if(cfg){
          if(cfg.backgroundType==='one-solid'&&cfg.backgroundColor){fill.replaceChildren();fill.style.backgroundColor=cfg.backgroundColor;}
          else if((cfg.backgroundType==='two-columns'||cfg.backgroundType==='two-rows'||cfg.backgroundType?.includes('solid'))&&cfg.backgroundColor2){fill.replaceChildren();fill.style.backgroundImage=`linear-gradient(${cfg.backgroundType==='two-rows'?'180deg':'90deg'},${cfg.backgroundColor} 50%,${cfg.backgroundColor2} 50%)`;}
          else if(typeof cfg.backgroundImage==='string'&&/^https:\/\//.test(cfg.backgroundImage)){fill.replaceChildren();fill.style.backgroundImage=`url("${cfg.backgroundImage.replaceAll('"','%22')}")`;}
          else if(cfg.backgroundType?.includes('variant')){const v=variants.find(v=>v.options[i]===value),media=v&&resolveGallery(v)[0];if(media){fill.replaceChildren();fill.style.backgroundImage=`url("${media.src}")`;}}
        }
        button.addEventListener('click',()=>{
          if(chosenOptions.has(i)&&selected.options[i]===value){
            chosenOptions.delete(i);form.dataset.mouniChoiceMade='false';update(selected);return;
          }
          const desired=[...selected.options]; desired[i]=value;
          const v=variants.find(v=>v.options.every((o,j)=>o===desired[j]))||variants.find(v=>v.available&&v.options[i]===value)||variants.find(v=>v.options[i]===value);
          chosenOptions.add(i); form.dataset.mouniChoiceMade=String(chosenOptions.size===fieldsets.length);
          update(v); input.dispatchEvent(new Event('change',{bubbles:true}));
        },{signal});
      });
    });
    input.addEventListener('change',()=>{const v=variants.find(v=>String(v.id)===input.value);if(v&&v.id!==selected.id)update(v);},{signal});
    card.querySelector('[data-gallery-next]').addEventListener('click',()=>{position=(position+1)%gallery.length;paintImages();},{signal});
    let touchX;
    const mediaLink=card.querySelector('.mhp__media');
    mediaLink.addEventListener('pointerdown',e=>{touchX=e.pointerType==='touch'?e.clientX:null;},{signal,passive:true});
    mediaLink.addEventListener('pointerup',e=>{if(touchX!==null&&Math.abs(e.clientX-touchX)>35&&gallery.length>1){card.dataset.swiped='true';position=(position+1)%gallery.length;paintImages();}touchX=null;},{signal,passive:true});
    mediaLink.addEventListener('click',e=>{if(card.dataset.swiped){e.preventDefault();delete card.dataset.swiped;}},{signal});
    update(selected);
  }
});

